import Link from "next/link";
import React from "react";
import { motion } from "framer-motion";
import "./ExclusiveOpportunities.css";

function ExclusiveOpportunities() {
  return (
    <section className="section-padding animated-radial-bg">
      <div className="main-container">
        <motion.div
          className="cp-vector"
          initial={{
            opacity: 0,
            scale: 0.8,
            rotate: -10,
          }}
          whileInView={{
            opacity: 1,
            scale: 1,
            rotate: 0,
          }}
          transition={{
            duration: 1,
          }}
          viewport={{ once: true }}
        >
          <img src="/images/home/cpvector.png" alt="" />
        </motion.div>

        <motion.div
          className="inner-flex section-padding-cp inner-flex-medium up-zindex inner-flex-center"
          initial={{
            opacity: 0,
            y: 60,
          }}
          whileInView={{
            opacity: 1,
            y: 0,
          }}
          transition={{
            duration: 0.8,
          }}
          viewport={{ once: true, amount: 0.3 }}
        >
          <div className="inner-flex iinner-more">
            <motion.div
              className="section-title"
              initial={{
                opacity: 0,
                y: 25,
              }}
              whileInView={{
                opacity: 1,
                y: 0,
              }}
              transition={{
                duration: 0.7,
                delay: 0.15,
              }}
              viewport={{ once: true }}
            >
              <h2 className="white-color">
                Become a Channel Partner <br className="hide-tab-mobile" />
                with us to unlock exclusive opportunities.
              </h2>
            </motion.div>
            <motion.div
              className="section-subtitle"
              initial={{
                opacity: 0,
                y: 25,
              }}
              whileInView={{
                opacity: 1,
                y: 0,
              }}
              transition={{
                duration: 0.7,
                delay: 0.15,
              }}
              viewport={{ once: true }}
            >
              <h4
                className="light-fonts white-color"
                style={{ fontStyle: "italic" }}
              >
                “110+ Members have registered.”
              </h4>
            </motion.div>
          </div>

          <motion.div
            initial={{
              opacity: 0,
              scale: 0.9,
            }}
            whileInView={{
              opacity: 1,
              scale: 1,
            }}
            transition={{
              duration: 0.6,
              delay: 0.3,
            }}
            viewport={{ once: true }}
          >
            <Link href="/channelpartner">
              <button className="reecosys-template-button button-style-white">
                <p>Register Now</p>
              </button>
            </Link>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}

export default ExclusiveOpportunities;
